import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadUserFromCookie, validateToken } from "./features/user/userSlice";

import Login from "./pages/Login";
// import Dashboard from './pages/Dashboard';
import UserManagement from "./pages/UserManagement";
import Profile from "./pages/Profile";
import Aircraft from "./pages/Aircraft";
import Manufactuer from "./pages/Manufactuer";
import AddManufacturer from "./pages/AddManufactuere";
import AddAircraft from "./pages/AddAircraft";
import ForgetPassword from "./pages/ForgetPassword";
import VerifyOTP from "./pages/VerifyOTP";
import CreateNewPassword from "./pages/ResetPassword";
import UserDetails from "./pages/UserDetails";
import ManufacturerDetails from "./pages/ManufactuerDetails";
import UpdateManufacturer from "./pages/UpdateManufacturer";
import ContentManagement from "./pages/ContentManagement";
import AircraftDetail from "./pages/AircraftDetail";
import UpdateAircraft from "./pages/UpdateAircraft";
import SubAdmin from "./pages/SubAdmin";
import AddSubAdmin from "./pages/AddSubAdmin";
import DesignHtml from "./pages/designHtml";
import GameLevels from "./pages/GameLevels";
import GameQuestion from "./pages/GameQuestion";
import GameSets from "./pages/GameSets";
import GameRoles from "./pages/GameRoles";
import BlackBoxListDetails from "./pages/BlackBoxListDetails";
import ReportMangement from "./pages/ReportMangement";
import ReportQuestion from "./pages/ReportQuestion";
import ReportSelectGame from "./pages/ReportSelectGame";
import BlackBoxLevels from "./pages/BlackBoxLevels";
import BlackBoxList from "./pages/BlackBoxList";
import AdminDetail from "./pages/AdminDetail";
import SubscriptionManagement from "./pages/SubscriptionManagement";
import AddOnManagement from "./pages/AddOnManagement";
// import ImageGame from "./pages/ImageGame";
import DirectQuestionSetGameSets from "./pages/GameSets2";
import DirectQuestionSetGameQuestions from "./pages/GameQuestion2";

import UploadGlossaryDetails from "./pages/UploadGlossary";
import UploadAviationChronicle from "./pages/AviationChronicle";
import UploadAirPortsDetails from "./pages//UploadAirport";
import UploadManufacturerDetails from "./pages//UploadManufacturer";
import UploadAircraftDetails from "./pages//UploadAirCraft"
import OfflinePopup from "./components/OfflinePopup";
import GlossaryManagement from "./pages/Glossary";
import AirportManagement from "./pages/Airport";
import AirportUpdate from "./pages/UpdateAirport";
import AirportDetails from "./pages/AirportDetail";
import AddAirport from "./pages/AddAirport";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useSelector((state) => state.user);

  if (loading) {

    const loading_design = <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>

    return loading_design;
  }

  return user ? children : <Navigate to="/login" replace />;
};

// PublicRoute component
const PublicRoute = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  return user ? <Navigate to="/" replace /> : children;
};

function App() {
  const dispatch = useDispatch();
  // const basename = "/";
  const basename = "/admin";

  // const user = useSelector((state) => state.user.user);
  useEffect(() => {
    dispatch(loadUserFromCookie()).then((res) => {
      if (res.payload) {
        dispatch(validateToken());
      }
    });
  }, [dispatch]);

  return (
    <Router basename={basename}>
      <OfflinePopup />
      <Routes>
        {/* Public Route */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route path="/forget" element={<ForgetPassword />} />
        <Route path="/verify" element={<VerifyOTP />} />
        <Route path="/createnewpassword" element={<CreateNewPassword />} />

        {/* Protected Route */}

        <Route
          path="/"
          // element={<PrivateRoute> <Dashboard /> </PrivateRoute>}
          element={
            <PrivateRoute>
              {" "}
              <UserManagement />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              {" "}
              <Profile />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/user"
          element={
            <PrivateRoute>
              <UserManagement />
            </PrivateRoute>
          }
        />

        <Route
          path="/user/:id"
          element={
            <PrivateRoute>
              <UserDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/aircraft"
          element={
            <PrivateRoute>
              <Aircraft />
            </PrivateRoute>
          }
        />
        <Route
          path="/aircraft-create"
          element={
            <PrivateRoute>
              <AddAircraft />
            </PrivateRoute>
          }
        />

        <Route
          path="/aircraft/:id"
          element={
            <PrivateRoute>
              <AircraftDetail />
            </PrivateRoute>
          }
        />

        <Route
          path="/aircraft/update/:id"
          element={
            <PrivateRoute>
              <UpdateAircraft />
            </PrivateRoute>
          }
        />

        <Route
          path="/manufacturer"
          element={
            <PrivateRoute>
              <Manufactuer />
            </PrivateRoute>
          }
        />
        <Route
          path="/manufacturer-create"
          element={
            <PrivateRoute>
              <AddManufacturer />
            </PrivateRoute>
          }
        />

        <Route
          path="/manufacturer/:id"
          element={
            <PrivateRoute>
              <ManufacturerDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/manufacturer/update/:id"
          element={
            <PrivateRoute>
              <UpdateManufacturer />
            </PrivateRoute>
          }
        />

        <Route
          path="/sub-admin"
          element={
            <PrivateRoute>
              <SubAdmin />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-sub-admin"
          element={
            <PrivateRoute>
              <AddSubAdmin />
            </PrivateRoute>
          }
        />

        <Route path="/admin/:id" element={<AdminDetail />} />

        <Route
          path="/content"
          element={
            <PrivateRoute>
              <ContentManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/subscriptions"
          element={
            <PrivateRoute>
              <SubscriptionManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/subscription-add-ons"
          element={
            <PrivateRoute>
              <AddOnManagement />
            </PrivateRoute>
          }
        />

        <Route path="/design" element={<DesignHtml />} />
        <Route
          path="/game-management/:game"
          element={
            <PrivateRoute>
              <GameLevels />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-management/:game/:level"
          element={
            <PrivateRoute>
              <GameRoles />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-management/:game/:level/:role"
          element={
            <PrivateRoute>
              <GameSets />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-management/:game/:level/:role/:set"
          element={
            <PrivateRoute>
              <GameQuestion />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-management/black-box-game"
          element={
            <PrivateRoute>
              <BlackBoxLevels />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-management/black-box-game/:id"
          element={
            <PrivateRoute>
              <BlackBoxList />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-management/black-box-game/:id/:questionId"
          element={
            <PrivateRoute>
              <BlackBoxListDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/report-select-game"
          element={
            <PrivateRoute>
              <ReportSelectGame />
            </PrivateRoute>
          }
        />
        <Route
          path="/report/:game"
          element={
            <PrivateRoute>
              <ReportMangement />
            </PrivateRoute>
          }
        />
        <Route
          path="/report/reportDetails/:game/:setId/:questionId"
          element={
            <PrivateRoute>
              <ReportQuestion />
            </PrivateRoute>
          }
        />
        <Route
          path="/game-question-set/:gameName"
          element={
            <PrivateRoute>
              <DirectQuestionSetGameSets />
            </PrivateRoute>
          }
        />

        <Route
          path="/game-question-set/:gameName/:setId"
          element={
            <PrivateRoute>
              <DirectQuestionSetGameQuestions />
            </PrivateRoute>
          }
        />

        {/* <Route
        path="/image-game"
          element={
            <PrivateRoute>
              <ImageGame />
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/upload-glossary"
          element={
            <PrivateRoute>
              <UploadGlossaryDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/upload-aviation-chronicle"
          element={
            <PrivateRoute>
              <UploadAviationChronicle />
            </PrivateRoute>
          }
        />

        <Route
          path="/upload-airports"
          element={
            <PrivateRoute>
              <UploadAirPortsDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/upload-manufacturers"
          element={
            <PrivateRoute>
              <UploadManufacturerDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/upload-aircraft"
          element={
            <PrivateRoute>
              <UploadAircraftDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/glossary"
          element={
            <PrivateRoute>
              <GlossaryManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/airport"
          element={
            <PrivateRoute>
              <AirportManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/airport/update/:id"
          element={
            <PrivateRoute>
              <AirportUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/airport/:id"
          element={
            <PrivateRoute>
              <AirportDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/airport-create"
          element={
            <PrivateRoute>
              <AddAirport />
            </PrivateRoute>
          }
        />


        {/* public Route */}
        <Route path="*" element={<Navigate to={"/login"} replace />} />
      </Routes>
    </Router>
  );
}

export default App;
